import '../../assets/plugins/react-charts.css';
import './DashboardPB.css';

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';
import config from '../../config/config';
import ApiPowerBI from '../../api/ApiPowerBI';
import PowerBiComponent from './PowerBiComponent';
import Authority from '../../util/Authority';

export enum DashboardTypes {
  GESTION = "CGESTION",
  OPERATIVO = "OPERATIVO",
  MOBILITY = "MOBILITY"
}

interface DashboardPowerBIProps {
  dashboardType: DashboardTypes;
}

interface DashboardState {
  companyId: number;
  loading: boolean;
  reportId: string;
  reportToken: string;
  error: string | null;
  type?: DashboardTypes;
}

const DashboardPowerBI: React.FC<DashboardPowerBIProps> = ({ dashboardType }) => {

  const { t } = useTranslation();
  const [state, setState] = useState<DashboardState>({
    companyId: 1,
    loading: true,
    reportId: '',
    reportToken: '',
    error: null,
  });

  useEffect(() => {
    const companyId = Authority.getAuthorizedCompanyId() ?? 1;
    setState(prev => ({ ...prev, companyId }));
    ApiPowerBI.callReport(dashboardType, onSuccess, onError);
  }, [dashboardType]);

  const onSuccess = (data: { reportToken: string; reportId: string }) => {
    setState({
      ...state,
      type: dashboardType,
      reportToken: data.reportToken,
      reportId: data.reportId,
      error: null,
      loading: false,
    });
  };

  const onError = () => {
    setState(prev => ({
      ...prev,
      loading: false,
    }));
  };

  if (state.loading) {
    return <div />;
  }

  if (state.reportToken) {
    const cookies = new Cookies();
    const lang = cookies.get('lang') ?? config.getLang() ?? 'es';

    return (
      <div style={{ width: '100%', height: '100%' }}>
        <PowerBiComponent
          reportId={state.reportId}
          reportToken={state.reportToken}
          lang={lang}
        />
      </div>
    );
  }

  return <div>{t('table.loading') as string}</div>;
};

export default DashboardPowerBI; 